export default __webpack_public_path__ + "static/008-4155df14d7c2cb722f6d75d8656d5346.jpg";